export function startFactoryStampEffect({ imgPanelEl }) {
  if (!imgPanelEl) return () => {};

  const timeoutId = setTimeout(() => {
    if (!imgPanelEl.isConnected) return;
    const prev = imgPanelEl.style.filter;
    imgPanelEl.style.filter = 'brightness(2)';
    setTimeout(() => {
      if (!imgPanelEl.isConnected) return;
      imgPanelEl.style.filter = prev || '';
    }, 100);
  }, 1000);

  return () => {
    clearTimeout(timeoutId);
  };
}
